import { Component, Input } from '@angular/core';
import { IconProp } from '@fortawesome/fontawesome-svg-core';

@Component({
	selector: 'portals-icon-toggle',
	templateUrl: './icon-toggle.component.html',
	styleUrls: ['./icon-toggle.component.scss'],
})
export class IconToggleComponent {
	@Input() value!: string;
	@Input() onIcon!: IconProp;
	@Input() offIcon!: IconProp;
	@Input() onColor!: string;
	@Input() offColor!: string;
}
